import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

function Counter({ label, value, sub, color, onClick }) {
  return (
    <button onClick={onClick} data-testid={`hub-counter-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
      className="text-left rounded-xl bg-white border border-slate-200 p-4 hover:border-slate-300 hover:shadow-sm transition-all">
      <div className="text-2xl font-heading font-semibold" style={{ color }}>{value}</div>
      <div className="text-xs text-slate-500 mt-0.5">{label}</div>
      {sub != null && <div className="text-[11px] text-slate-400 mt-1">{sub}</div>}
    </button>
  );
}

export default function OperatorHome() {
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/hub/overview").then((r) => setData(r.data)).catch(() => setData({ recent: [], counters: {} })); }, []);

  const c = data?.counters || {};

  return (
    <div className="mb-8" data-testid="operator-home">
      {/* Counters */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Counter label="Anagrafiche" value={c.anagrafiche ?? "—"} color="#1B2380" onClick={() => nav("/anagrafiche")} />
        <Counter label="Preventivi RC" value={c.rc_totali ?? "—"} sub={c.rc_bozze ? `${c.rc_bozze} in bozza` : "nessuna bozza"} color="#10B981" onClick={() => nav("/quotatore-rc/preventivi")} />
        <Counter label="Pratiche Cauzioni" value={c.cau_totali ?? "—"} sub={c.cau_da_valutare ? `${c.cau_da_valutare} da valutare` : "tutte valutate"} color="#F97316" onClick={() => nav("/cauzioni-pro")} />
        <Counter label="Pratiche MUP" value={c.mup_totali ?? "—"} sub={c.mup_da_firmare ? `${c.mup_da_firmare} da firmare` : "nessuna in firma"} color="#1B2380" onClick={() => nav("/mup/pratiche")} />
      </div>
    </div>
  );
}
